import React, { useState } from 'react';
import { RadioGroup, FormControlLabel, Radio } from "@material-ui/core";
import NumberFormat from 'react-number-format';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { useFormik } from 'formik';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

export default function FinanceHistory(props) {
	const [selectedDate, setSelectedDate] = useState();
	const [amount, setAmount] = useState()
	const [totalMortgage, setTotalMortgage] = useState()
	const [error,setError] = useState();
	const [futureError,setFutureError] = useState();

	const handleDateChange = (date) => {

		if (date === null || isNaN(date)) {
			setError(true);
			setFutureError(false);
		} else {
			setError(false);
			if (date > new Date()) {
				setFutureError(true);
		  	} else {
			setFutureError(false);
		  	}	
		}  

		if (date !== null) {
			setSelectedDate(moment(date).format('MM/DD/YYYY'));
			props.values.purchased_date = moment(date).format('MM/DD/YYYY')
			props.formik && props.formik.setFieldValue('purchased_date', moment(date).format('MM/DD/YYYY'))
		} else {
			props.values.purchased_date = null
		}
		if ((selectedDate === null || selectedDate === undefined || selectedDate === "Invalid date") && props.values.price_paid === '' && props.values.total_mortgage === '' && props.values.total_mortgage_amount === '' && (props.values.estimate === '' || props.values.estimate !== "This is original mortgage amount" || props.values.estimate !== "This is current unpaid balance")) {
			props.values.finance_not_sure = true
		} else {
			props.values.finance_not_sure = false
		}
	};
	const formik = useFormik({})
	function StyledRadio(props) {
		const useStyles = makeStyles({
			root: {
				'&:hover': {
					backgroundColor: 'transparent',
				},
			}
		})
		const classes = useStyles();
		return (
			<Radio
				className={classes.root}
				disableripple="true"
				color="default"
				checkedIcon={<CheckCircleIcon className="checkedIcon" />}
				icon={<RadioButtonUncheckedIcon />}
				{...props}
			/>
		);
	}
	const resetInputField = () => {
		if (props.values.estimate === "no") {
			setTotalMortgage("") || setAmount("");
			props.values.total_mortgage = '';
			props.values.total_mortgage_amount = '';
		}
	};

	return (
		<div className="form-question">
			<div className="form-content" >
				<h4 className="form-content-heading m-0">
					Can you tell us about the purchase and finance history of the home?
				</h4>
				<div className="pt-2 form-content-field">
					<div className="py-2">
						<div className="w-res-50 py-2">
							<div className="pb-2">
								<h6 className="m-0">When did you purchase the home?</h6>
							</div>
							<div>
								<MuiPickersUtilsProvider utils={DateFnsUtils}>
									<KeyboardDatePicker
										margin="normal"
										id="date-picker-dialog"
										format="MM/dd/yyyy"
										placeholder="MM/DD/YYYY"
										name="purchased_date"
										style={{ marginTop: '0px' }}
										value={props.values.purchased_date}
										onChange={handleDateChange}
										className="w-100"
										disableFuture={true}
										inputVariant="outlined"
										error={error || futureError}  
        								helperText={
        								  error ? "Invalid Date Format" :
        								  futureError ? "Date should not be in the future" : ""
        								}
										KeyboardButtonProps={{
											'aria-label': 'change date',
										}}
									/>
								</MuiPickersUtilsProvider>
							</div>
						</div>
						<div className="w-res-50 py-2">
							<div className="pb-2">
								<h6 className="m-0">What was the purchase price for the home?</h6>
							</div>
							<div>
								<NumberFormat
									className="amount-field"
									thousandSeparator={','}
									decimalSeparator={'.'}
									autoComplete='off'
									decimalScale={2}
									prefix="$"
									allowNegative={false}
									maxLength="10"
									inputMode="numeric"
									id="purchasePrice"
									name="price_paid"
									value={props.values.price_paid}
									onChange={props.handleChange}
									allowEmptyFormatting />
							</div>
						</div>
						<div className="py-2">
							<h6>What do you think the home is worth today?</h6>
							<div className="w-res-50">
								<div>
									<NumberFormat
										className="amount-field"
										thousandSeparator={','}
										decimalSeparator={'.'}
										autoComplete='off'
										prefix="$"
										allowNegative={false}
										decimalScale={2}
										maxLength="10"
										id="homeWorth"
										inputMode="numeric"
										name="home_worth"
										value={props.values.home_worth}
										onChange={props.handleChange}
										allowEmptyFormatting />
								</div>
							</div>
						</div>
						<div className="w-res-75 py-2">
							<div className="py-2">
								<h6 className="m-0">Is there a mortgage on the home?</h6>
							</div>
							<div className="">
								<RadioGroup
									row name="estimate"
									value={props.values.estimate}
									onClick={resetInputField}
									onChange={props.handleChange}
								>
									<div >
										<FormControlLabel value="yes" control={<StyledRadio />} label="Yes" />
									</div>
									<div >
										<FormControlLabel value="no" control={<StyledRadio />} label="No" />
									</div>
								</RadioGroup>
							</div>
						</div>
						{props.values.estimate === "yes" ?
							<>
								<div className="w-res-50 py-2 px-3">
									<div className="col-12">
										<h6 style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-semibold"}:{}}>What is the estimated total mortgage amount?</h6>
										<NumberFormat
											className="amount-field"
											thousandSeparator={','}
											decimalSeparator={'.'}
											autoComplete='off'
											decimalScale={2}
											prefix="$"
											allowNegative={false}
											maxLength="10"
											inputMode="numeric"
											name="total_mortgage"
											value={props.values.total_mortgage}
											onChange={props.handleChange}
											allowEmptyFormatting />
									</div>
								</div>

								<div className="w-res-50 py-2 px-3">
									<div className="pb-2 col-12">
										<h6 className="m-0" style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-semibold"}:{}}>What is the monthly mortgage payment amount?</h6>

									</div>
									<div className="col-12">
										<NumberFormat
											className="amount-field"
											thousandSeparator={','}
											decimalSeparator={'.'}
											autoComplete='off'
											prefix="$"
											allowNegative={false}
											decimalScale={2}
											maxLength="10"
											inputMode="numeric"
											name="total_mortgage_amount"
											value={props.values.total_mortgage_amount}
											onChange={props.handleChange}
											allowEmptyFormatting />
									</div>
								</div>
							</> : ''}
						{props.validateDisplay2 === true ?
							props.errors.finance_history ?
								<div className="error-msg" style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-Light"}:{}}>{props.errors.finance_history}</div> : ''
							: ''}
					</div>
				</div>
			</div>
		</div>
	)
}

